import PropTypes from 'prop-types';

import CollectionListItem from './collection';
import BroadcastListItem from './broadcast';

const ListItem = ({isCollectionMandate, ...rest}) => (
  isCollectionMandate ?
    <CollectionListItem {...rest}/> :
    <BroadcastListItem {...rest}/>
);

ListItem.propTypes = {
  isCollectionMandate: PropTypes.bool.isRequired
};

export default ListItem;
